export default () => {
    let table = document.querySelector('.table');
    if (table) {
        let fixedColumn = table.cloneNode(true);
        let tableParent = table.parentElement;
        tableParent.insertBefore(fixedColumn, table.previousSibling);
        fixedColumn.classList.add('fixed-column');

        let fixedColumnClass = document.querySelector('.fixed-column');

        // Final found elements
        let found_elements = [];
        let elements_in_outer = fixedColumnClass.querySelectorAll("th:not(:first-child), td:not(:first-child)");
        elements_in_outer = Array.prototype.slice.call(elements_in_outer);
        found_elements = found_elements.concat(elements_in_outer);

        //Remove elements
        found_elements.forEach(item => {
            item.remove();
        });

        // Final found elements
        let found_elements_tr_arr = [];
        let elements_in_outer_tr = fixedColumnClass.querySelectorAll("tr");
        elements_in_outer_tr = Array.prototype.slice.call(elements_in_outer_tr);
        found_elements_tr_arr = found_elements_tr_arr.concat(elements_in_outer_tr);

        let found_elements_tr_arr1 = [];
        let table_tr_height = [];

        let table_elements_tr = table.querySelectorAll('tr');

        table_elements_tr.forEach(function (item) {
            let itemHeight = item.offsetHeight;
            table_tr_height.push(itemHeight);
        });

        found_elements_tr_arr.forEach(function (newItem, i) {
            newItem.style.height = table_tr_height[i] + 'px';
        });
    }
}